import { IsNotNull } from '../../controllers/commons/helper';

import { withRouter,Redirect } from "react-router-dom"
const { crypter_s } = require("../../controllers/encrypt/encrypt");
const jwt = require("jsonwebtoken");

const AuthVerifyComponent = ({ history }) => {
  history.listen(async () => {  // <--- Here you subscribe to the route change
    if (IsNotNull(localStorage.getItem("authUser"))) {
      let tkn = JSON.parse(localStorage.getItem("authUser")).token
      if (IsNotNull(tkn)) {
        let decrypted = await crypter_s().decrypt(tkn)
        let rs_d = jwt.decode(decrypted);
        if (rs_d.exp * 1000 < Date.now()) {
          localStorage.clear();
          history.push("/login")
        }
      } else {
        localStorage.clear();
        history.push("/login")
      }
    }
  });
  return <div></div>;
};

export default withRouter(AuthVerifyComponent);